module.exports = __webpack_public_path__ + "static/anisha-bb7a02ced83e30f33a7b961c3117bca2.png";